import { render, staticRenderFns } from "./FormPageBulk.vue?vue&type=template&id=4fdc9021&scoped=true&"
import script from "./FormPageBulk.vue?vue&type=script&lang=js&"
export * from "./FormPageBulk.vue?vue&type=script&lang=js&"
import style0 from "./FormPageBulk.vue?vue&type=style&index=0&id=4fdc9021&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdc9021",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fdc9021')) {
      api.createRecord('4fdc9021', component.options)
    } else {
      api.reload('4fdc9021', component.options)
    }
    module.hot.accept("./FormPageBulk.vue?vue&type=template&id=4fdc9021&scoped=true&", function () {
      api.rerender('4fdc9021', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Manda/FormPageBulk.vue"
export default component.exports